import {
    ORDERED_PAY_COMPONENT,
    PayComponent,
} from 'routes/HumanResourcesModule/PayState/helpers/constants';
import { SALARY_RAW_CHARGED_FIELD } from 'routes/HumanResourcesModule/business/definitions';
import {
    DashDateString,
    SalaryRawChargedFieldByPayComponentAndMonth,
} from 'routes/HumanResourcesModule/business/types';
import { TablePayCompSalaryMassIndicatorsT } from '../../helpers/hooks/payStateIndicators';
import { DataPointT } from '../../components/PayStateBanner';
import { currencyFormatter } from 'helpers/formatHelper';

// Method to get the list of pivot suffixes issued from pivoted data keys
// TODO: implement an intelligent typing for this method to make sure the
// the return type is an array of T extending string, T being the type
// of the suffixes of the keys
export function extractPivotedSuffixes(
    data: Record<string, unknown>[],
): string[] {
    if (data.length === 0) return [];
    const pivotedKeys = Object.keys(data[0]).filter((key) =>
        key.includes('..'),
    );
    const pivotedSuffixes = pivotedKeys.map((key) => key.split('..')[1]);
    return Array.from(new Set(pivotedSuffixes));
}

export function sortPayComponents(
    payComponentA: PayComponent,
    payComponentB: PayComponent,
): number {
    const indexA = ORDERED_PAY_COMPONENT.indexOf(payComponentA);
    const indexB = ORDERED_PAY_COMPONENT.indexOf(payComponentB);
    return indexA - indexB;
}

export function shouldAddOtherPayComponent(
    payComponents: PayComponent[],
): boolean {
    return payComponents.includes(PayComponent.BRUT);
}

export const getPayComponentSalaryField = (
    payComponent: PayComponent,
    suffix: DashDateString,
): SalaryRawChargedFieldByPayComponentAndMonth =>
    `${SALARY_RAW_CHARGED_FIELD}..${payComponent}..${suffix}`;

/** Format the table indicators for Pay Component Salary Mass to be able to be consumed by the banner. */
export const formatTableIndicators = (
    indicators: TablePayCompSalaryMassIndicatorsT | undefined,
): DataPointT[] => {
    if (indicators === undefined) {
        return [];
    }
    return [
        {
            current: indicators.currentExercice.salaryValue,
            deltaFormatted: currencyFormatter(
                indicators.currentExercice.salaryValue -
                    (indicators.previousExercice
                        ? indicators.previousExercice.salaryValue
                        : 0),
            ),
            ...(indicators.previousExercice
                ? { previous: indicators.previousExercice.salaryValue }
                : {}),
        },
    ];
};
